import TagInfoModal from './TagInfoModal'

export default TagInfoModal

